<template>
    <div>
        <v-navigation-drawer 
            v-model="drawer" 
            app
            floating
            :permanent="drawer"
            :mini-variant.sync="mini"
            width="350px"
        >
            <v-tabs
                v-model="tab"
                background-color="primary"
                vertical
                dark
                class="line-sidebar"
            >
                <div class="logo accent">
                    <img src="@/assets/logo-nav.png" style="width: 50%;" class="ma-auto" alt="logo">
                </div>

                <v-tab href="#plants">
                    <v-icon>mdi-lightning-bolt-circle</v-icon>
                </v-tab>

                <v-spacer></v-spacer>

                <div class="d-none d-md-flex">
                    <userMenu class="ma-auto"/>
                </div>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item :value="'plants'" class="h-100">
                    <v-card  flat class="h-100">
                        <div class="title">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Plantas
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Plantas registradas
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-icon >
                                    <v-btn icon @click="mini = !mini" class="d-none d-md-block">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="detectAction(false)" class="d-md-none">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="ma-0 text-center" style="font-size: 10px">
                                <v-icon x-small color="accent" @click="filterStatus('accent')">mdi-lightning-bolt-circle</v-icon> Conectado
                                <v-icon x-small color="yellow accent-4" @click="filterStatus('yellow accent-4')">mdi-lightning-bolt-circle</v-icon> Ultimas {{parseInt(minutesToWarn / 60)}} horas
                                <v-icon x-small color="red darken-3" @click="filterStatus('red darken-3')">mdi-lightning-bolt-circle</v-icon> Ultimas {{parseInt(minutesToDanger / 60)}} horas
                            </div>
                            <v-text-field
                                v-model="filter_plants.filter"
                                clearable
                                solo
                                outlined
                                dense
                                flat
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                class="mx-3 mt-3"
                                @keypress="filterPlants"
                            ></v-text-field>
                        </div>
                        <v-card-text class="pa-0 list-body">
                            <v-list  flat dense three-line>
                                <v-list-item-group v-if="filter_plants.filter === '' || filter_plants.filter === null">
                                    <v-divider></v-divider>
                                    <template v-for="(plant, index) in gateways">
                                        <v-list-item 
                                            :key="plant.id" 
                                            color="primary"
                                            active-class="active-plant"
                                            @click="changeView(plant.id)">

                                            <v-list-item-icon class="mr-2 mt-3">
                                                <v-icon 
                                                    small 
                                                    v-if="colorStatus.find( g => g.id === plant.id)"
                                                    :color="colorStatus.find( g => g.id === plant.id).color">
                                                    mdi-lightning-bolt-circle
                                                </v-icon>
                                                <v-icon small v-else>mdi-lightning-bolt-circle</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title class="name-plant">{{ plant.name }}</v-list-item-title>
                                                <v-list-item-subtitle style="margin-top: -10px;">{{ plant.description }}</v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action v-if="plant.id === selected && userAtLeastIs(user, LEVEL_ADMIN)">
                                                <v-btn icon @click="editAction">
                                                    <v-icon small>
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn icon @click="deletePlant">
                                                    <v-icon small>
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item-action>

                                        </v-list-item>
                                        <v-divider :key="index" class="ma-0"></v-divider>
                                    </template>
                                </v-list-item-group>
                                <v-list-item-group v-else>
                                    <v-divider></v-divider>
                                    <template v-for="(plant, index) in filter_plants.data">
                                        <v-list-item 
                                            :key="plant.id" 
                                            color="primary"
                                            active-class="active-plant"
                                            @click="changeView(plant.id)">

                                            <v-list-item-icon class="mr-2 mt-3">
                                                <v-icon 
                                                    small 
                                                    v-if="colorStatus.find( g => g.id === plant.id)"
                                                    :color="colorStatus.find( g => g.id === plant.id).color">
                                                    mdi-lightning-bolt-circle
                                                </v-icon>
                                                <v-icon small v-else>mdi-lightning-bolt-circle</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title class="name-plant">{{ plant.name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ plant.description }}</v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-action v-if="plant.id === selected && userAtLeastIs(user, LEVEL_ADMIN)">
                                                <v-btn icon @click="editAction">
                                                    <v-icon small>
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn icon @click="deletePlant">
                                                    <v-icon small>
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </v-list-item-action>

                                        </v-list-item>
                                        <v-divider :key="index" class="ma-0"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                        <div class="buttons-action pa-2" v-if="!mini">
                            <v-btn v-if="view == 'Plant'" class="mb-3" block color="accent" @click="changeView(null, 'Map')">
                                <v-spacer>Ver mapa</v-spacer> <v-icon>mdi-map-marker</v-icon>
                            </v-btn>
                            <v-btn v-else-if="view == 'Map'" class="mb-3" block color="accent" @click="changeView(null, 'Plant')">
                                <v-spacer>Ver dashboard</v-spacer> <v-icon>mdi-view-dashboard</v-icon>
                            </v-btn>
                            <v-btn color="accent" block @click="actionNew" v-if="userAtLeastIs(user, LEVEL_ADMIN)">
                                <v-spacer>Añadir nuevo</v-spacer> <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </div>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-navigation-drawer>

        <formGateway 
            :open="gtw_form.open" 
            @close="actionClose" 
            :id="gtw_form.id"/>

        <deleteGateway
            :open="delete_form.open"
            :id="delete_form.id"
            @close="closeDelete"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission'
import userMenu from './user-menu'
import formGateway from '../formGateway'
import deleteGateway from '../deleteGateway'

export default {
    name: 'sidebar',
    props: ['drawer'],
    computed: {
        ...mapState({
            user: state => state.user.profile.level,
            gateways: state => state.gateways.list,
            selected: state => state.gateways.selected,
            view: state => state.user.view,
            lastReadings: state => state.meters.lastReadings,
            minutesToWarn: state => state.account.profile.minutesToWarn,
            minutesToDanger: state => state.account.profile.minutesToDanger,
            colorStatus(state){
                if( this.gateways === null || this.lastReadings === null) 
                    return []
                
                let gtws = this.gateways.map( g => {
                    const reads = this.lastReadings
                        .filter( r => g.consumption.includes(r.meter) || g.generation.includes(r.meter))

                    const lastRead = reads.reduce((acc, r) => {
                        const date = new Date(r.timestamp)
                        if(acc === null || acc > date)
                            acc = date
                        return acc
                    }, null)

                    let color = 'accent'
                    const now = new Date().getTime()
                    if(lastRead == null) color = 'blue-grey darken-1'
                    else if(now - lastRead.getTime() > this.minutesToDanger * 1000 * 60) color = 'red darken-3'
                    else if(now - lastRead.getTime() > this.minutesToWarn * 1000 * 60) color = 'yellow accent-4'

                    return { id: g.id, color }
                } )
                
                return gtws
            }
        })
    },
    components: { formGateway, userMenu, deleteGateway },
    data() {
        return {
            mini: false,
            tab:null,
            gtw_form:{
                open: false,
                id: null
            },
            delete_form:{
                open: false,
                id: null
            },
            filter_plants: {
                data: [],
                filter: ''
            },
            LEVEL_ADMIN
        }
    },
    methods: {
        ...mapActions({ 
            updateSelected: 'gateways/updatedGatewaySelected',
            updatedView: 'user/updatedView'
        }),
        userAtLeastIs,
        changeView(id, view){
            if(id) this.updateSelected(id)
            if(view){
                if(view === this.view) return
                this.$router.push({ name: view })
            }else{
                if(this.$router.currentRoute.name === this.view) return
                this.$router.push({ name: this.view })
            }
            
        },
        detectAction(value) {
            value = !undefined
                ? this.$emit('close-drawer', value)
                : this.$emit('close-drawer', this.drawer)
        },
        actionNew(){
            switch (this.tab) {
                case 'plants':
                    this.gtw_form.open = true
                    break;

                default:
                    break;
            }
        },
        editAction(){
            switch (this.tab) {
                case 'plants':
                    this.gtw_form.open = true
                    if(this.selected) this.gtw_form.id = this.selected
                    break;

                default:
                    break;
            }
        },
        actionClose(){
            switch (this.tab) {
                case 'plants':
                    this.gtw_form.id = null
                    this.gtw_form.open = false
                    break

                default:
                    break
            }
        },
        deletePlant(){
            this.delete_form.id = this.selected
            this.delete_form.open = true
        },
        closeDelete(){
            this.delete_form.id = null
            this.delete_form.open = false
        },
        filterStatus(color){
            this.filter_plants.filter = 'Filtro estatus'
            const data = this.colorStatus.filter( p => p.color === color )
            this.filter_plants.data = this.gateways.filter( plant => data.find(p => p.id == plant.id) )
        },
        filterPlants(){
            this.filter_plants.data = this.gateways.filter( p =>
                p.name
                    .toLowerCase()
                    .indexOf(this.filter_plants.filter.toLowerCase()) > -1 ||
                p.description
                    .toLowerCase()
                    .indexOf(this.filter_plants.filter.toLowerCase()) > -1
            )
        }
    },
    watch:{
        mini(){
            this.$emit('change-mini', this.mini)
        }
    }
}
</script>

<style scoped>
.h-100{
    height: 100%;
}
.logo{
    display: flex;
    height: 68px;
    width: 60px;
}
.v-tabs{
    position: absolute;
    height: 100%;
    width: 60px;
    left: 0;
    top: 0;
}
.v-tab{
    min-width: unset !important;
}
.v-tabs-items{
    margin-left: 60px;
    height: 100%;
}
.title{
    height: 22%;
}

.list-body{
    height: 65%;
    overflow-y: scroll;
    -ms-overflow-style: none; 
    scrollbar-width: none; 
}
.list-body::-webkit-scrollbar {
    display: none;
}

.active-plant{
    border-left: 5px solid var(--v-accent-base);
    border-right: 5px solid var(--v-accent-base);
    padding: 0px 10px;
    border-radius: 0px;
}
.name-plant{
    text-overflow: unset !important;
    white-space: unset !important;
}
.buttons-action{
    box-shadow: 0px 3px 16px 1px #0000005c;
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
    background-color: white;
}
</style>
